import { Trash2 } from "lucide-react";
import { useEffect, useState } from "react";
import { LineSheetsHeaderSection } from "./details-section/LineSheets";

interface CommentSectionProps {
  comment?: string;
  updateComment: (comment: string) => Promise<void>;
}

export const CommentSection = ({ comment, updateComment }: CommentSectionProps) => {
  const [currentComment, setCurrentComment] = useState(comment ?? "");
  const [isEditing, setIsEditing] = useState(false);
  const hasComment = currentComment.trim().length > 0;

  useEffect(() => {
    setCurrentComment(comment ?? "");
  }, [comment]);

  const handleEdit = () => setIsEditing(true);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => setCurrentComment(e.target.value);

  const handleBlur = async (e: React.FocusEvent<HTMLTextAreaElement>) => {
    const value = e.target.value.trim();
    // Always update the comment, even when it's empty
    await updateComment(value);
    setCurrentComment(value);
    setIsEditing(false);
  };

  const handleDelete = async () => {
    await updateComment("");
    setCurrentComment("");
    setIsEditing(false);
  };

  return (
    <div className={`my-4 flex w-full justify-center space-x-3 ${hasComment && !isEditing ? "items-start" : "items-center"}`}>
      <div className={`flex items-center space-x-2 text-sm font-medium whitespace-nowrap text-[#71717A]`}>
        <LineSheetsHeaderSection title="F9 Notes">
          <img alt="comment" src="/comment.svg" />
        </LineSheetsHeaderSection>
      </div>

      <div className="w-full px-4">
        {!hasComment && !isEditing && (
          <p onClick={handleEdit} className="cursor-pointer text-sm text-[#9ca3af] hover:text-gray-600">
            Text here will be exported as an F9 note.
          </p>
        )}

        {isEditing ? (
          <div className="flex w-full items-center gap-2">
            <textarea
              className="w-full resize-none rounded border border-gray-300 p-2"
              name="edit-comment"
              placeholder="Write a comment..."
              value={currentComment}
              onChange={handleChange}
              onBlur={handleBlur}
              autoFocus
              rows={3}
            />
          </div>
        ) : hasComment ? (
          <div className="group flex items-start space-x-2">
            <div onClick={handleEdit} className="p-3 text-sm leading-relaxed whitespace-pre-wrap">
              {currentComment}
            </div>
            <Trash2 color="#E45F58" className="h-4 w-4 cursor-pointer opacity-0 group-hover:opacity-100" onClick={handleDelete} />
          </div>
        ) : null}
      </div>
    </div>
  );
};
